import { render, staticRenderFns } from "./myOrderDetails.vue?vue&type=template&id=e1c80a20&scoped=true"
import script from "./myOrderDetails.vue?vue&type=script&lang=js"
export * from "./myOrderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c80a20",
  null
  
)

export default component.exports